const modullerData = {
  'kontrol-paneli': {
    id: 'kontrol-paneli',
    title: 'Gösterge Paneli',
    title_en: 'Dashboard',
    badge: 'MERKEZ KOMUTA',
    badge_en: 'COMMAND CENTER',
    description: 'BGYS\'nizin üst düzey görünümünü sağlayan merkezi kontrol paneli. Tüm kritik metrikleri tek bakışta görün.',
    description_en: 'Central control panel providing a high-level view of your ISMS. See all critical metrics at a glance.',
    icon: 'MdDashboard',
    image: '/images/Modules/gostergePaneli.png',
    features: [
      { title: 'Varlık İstatistikleri', title_en: 'Asset Statistics', description: '9 kategoride toplam varlıkların anlık görünümü', description_en: 'Real-time view of total assets across 9 categories', icon: 'MdInventory2' },
      { title: 'Risk Özeti', title_en: 'Risk Summary', description: 'Düşük, Orta, Yüksek ve Kritik risk dağılımı', description_en: 'Distribution of Low, Medium, High and Critical risks', icon: 'MdWarning' },
      { title: 'Kontrol Durumu', title_en: 'Control Status', description: 'ISO 27001 Ek A kontrollerinin uygulama durumu', description_en: 'Implementation status of ISO 27001 Annex A controls', icon: 'MdSecurity' },
      { title: 'Son Aktivite', title_en: 'Recent Activity', description: 'Sistem genelindeki en son değişiklikler ve güncellemeler', description_en: 'Latest changes and updates across the system', icon: 'MdUpdate' },
      { title: 'Uyumluluk Metrikleri', title_en: 'Compliance Metrics', description: 'Genel uyumluluk durumu ve ilerleme takibi', description_en: 'Overall compliance status and progress tracking', icon: 'MdCheckCircle' },
      { title: 'Hızlı Erişim', title_en: 'Quick Access', description: 'Acil dikkat gerektiren yüksek riskli öğeler', description_en: 'High-risk items requiring immediate attention', icon: 'MdSpeed' },
    ],
    stats: [
      { value: '9', label: 'Varlık Kategorisi', label_en: 'Asset Categories' },
      { value: '93', label: 'ISO Kontrolü', label_en: 'ISO Controls' },
      { value: '4', label: 'Risk Seviyesi', label_en: 'Risk Levels' },
      { value: '7/24', label: 'Canlı İzleme', label_en: 'Live Monitoring' },
    ],
  },

  'envanter': {
    id: 'envanter',
    title: 'Envanter Yönetimi',
    title_en: 'Asset Inventory Management',
    badge: 'VARLIK TAKİBİ',
    badge_en: 'ASSET TRACKING',
    description: 'Donanım, yazılım, veri ve personel dahil 9 farklı varlık türünü merkezi olarak yönetin. Her varlık için risk değerlendirmesi ve sınıflandırma yapın.',
    description_en: 'Centrally manage 9 different asset types including hardware, software, data and personnel. Perform risk assessment and classification for each asset.',
    icon: 'MdInventory',
    image: '/images/Modules/envanterYonetimi.png',
    features: [
      { title: 'Donanım Varlıkları', title_en: 'Hardware Assets', description: 'Sunucular, dizüstü bilgisayarlar ve ağ cihazları takibi', description_en: 'Tracking servers, laptops and network devices', icon: 'MdComputer' },
      { title: 'Yazılım Envanteri', title_en: 'Software Inventory', description: 'Uygulamalar ve işletim sistemleri yönetimi', description_en: 'Management of applications and operating systems', icon: 'MdApps' },
      { title: 'Veri Varlıkları', title_en: 'Data Assets', description: 'Bilgi varlıkları ve veritabanları kataloğu', description_en: 'Information assets and database catalog', icon: 'MdStorage' },
      { title: 'Personel Kayıtları', title_en: 'Personnel Records', description: 'Çalışanlar ve rolleri ile erişim yetkileri', description_en: 'Employees, roles and access permissions', icon: 'MdPeople' },
      { title: 'Risk Değerlendirme', title_en: 'Risk Assessment', description: 'Gizlilik, Bütünlük, Erişilebilirlik puanlaması', description_en: 'Confidentiality, Integrity, Availability scoring', icon: 'MdAssessment' },
      { title: 'Sınıflandırma', title_en: 'Classification', description: 'Genel, Dahili, Gizli, Kısıtlı seviyeleri', description_en: 'Public, Internal, Confidential, Restricted levels', icon: 'MdLabel' },
    ],
    assetTypes: [
      { name: 'Donanım', name_en: 'Hardware', icon: 'MdComputer' },
      { name: 'Yazılım', name_en: 'Software', icon: 'MdApps' },
      { name: 'Veri', name_en: 'Data', icon: 'MdStorage' },
      { name: 'Personel', name_en: 'Personnel', icon: 'MdPerson' },
      { name: 'Ağ Cihazları', name_en: 'Network Devices', icon: 'MdRouter' },
      { name: 'Belgeler', name_en: 'Documents', icon: 'MdDescription' },
      { name: 'Tesisler', name_en: 'Facilities', icon: 'MdBusiness' },
      { name: 'Fiziksel Medya', name_en: 'Physical Media', icon: 'MdUsb' },
      { name: 'Hizmetler', name_en: 'Services', icon: 'MdCloud' },
    ],
    stats: [
      { value: '9', label: 'Varlık Türü', label_en: 'Asset Types' },
      { value: '4', label: 'Sınıflandırma', label_en: 'Classifications' },
      { value: '1-3', label: 'Risk Ölçeği', label_en: 'Risk Scale' },
      { value: '4', label: 'Tedavi Seçeneği', label_en: 'Treatment Options' },
    ],
  },

  'risk': {
    id: 'risk',
    title: 'Risk Yönetimi',
    title_en: 'Risk Management',
    badge: 'RİSK ANALİZİ',
    badge_en: 'RISK ANALYSIS',
    description: 'Varlıklarınıza bağlı riskleri otomatik olarak hesaplayın, tedavi planları oluşturun ve ISO 27001 kontrollerine bağlayın.',
    description_en: 'Automatically calculate risks linked to your assets, create treatment plans and link to ISO 27001 controls.',
    icon: 'MdWarning',
    image: '/images/Modules/riskYonetimi.png',
    features: [
      { title: 'Otomatik Hesaplama', title_en: 'Automatic Calculation', description: 'Risk puanı = (Gizlilik + Bütünlük + Erişilebilirlik + Olasılık) / 4', description_en: 'Risk score = (C + I + A + Likelihood) / 4', icon: 'MdCalculate' },
      { title: 'Risk Seviyeleri', title_en: 'Risk Levels', description: 'Düşük (<4), Orta (4-6), Yüksek (≥7) kategorileri', description_en: 'Low (<4), Medium (4-6), High (≥7) categories', icon: 'MdTrendingUp' },
      { title: 'Tedavi Planları', title_en: 'Treatment Plans', description: 'Kabul Et, Azalt, Transfer Et, Kaçın seçenekleri', description_en: 'Accept, Mitigate, Transfer, Avoid options', icon: 'MdMedicalServices' },
      { title: 'Kontrol Bağlantısı', title_en: 'Control Linking', description: 'Riskleri ISO 27001 Ek A kontrollerine bağlama', description_en: 'Link risks to ISO 27001 Annex A controls', icon: 'MdLink' },
      { title: 'Artık Risk', title_en: 'Residual Risk', description: 'Tedavi sonrası kalan risk takibi', description_en: 'Track remaining risk after treatment', icon: 'MdShowChart' },
      { title: 'Yönetim Onayı', title_en: 'Management Approval', description: 'Risk tedavi kararları için onay süreçleri', description_en: 'Approval processes for risk treatment decisions', icon: 'MdApproval' },
    ],
    stats: [
      { value: '4', label: 'Risk Seviyesi', label_en: 'Risk Levels' },
      { value: '4', label: 'Tedavi Türü', label_en: 'Treatment Types' },
      { value: 'CIA+L', label: 'Hesaplama', label_en: 'Calculation' },
      { value: '∞', label: 'Risk Kaydı', label_en: 'Risk Records' },
    ],
  },

  'personel': {
    id: 'personel',
    title: 'Personel Yönetimi',
    title_en: 'Personnel Management',
    badge: 'KULLANICI YÖNETİMİ',
    badge_en: 'USER MANAGEMENT',
    description: 'Rol tabanlı erişim kontrolü ile kullanıcıları yönetin. Sistem rolleri, izinler ve sahiplik doğrulaması ile güvenliği sağlayın.',
    description_en: 'Manage users with role-based access control. Ensure security with system roles, permissions and ownership verification.',
    icon: 'MdPeople',
    image: '/images/Modules/personelYonetimi.png',
    features: [
      { title: 'Rol Tabanlı Erişim', title_en: 'Role-Based Access', description: 'Yönetici, BGYS Yöneticisi, Denetçi, Risk Yöneticisi rolleri', description_en: 'Admin, ISMS Manager, Auditor, Risk Manager roles', icon: 'MdAdminPanelSettings' },
      { title: 'Özel Roller', title_en: 'Custom Roles', description: 'İhtiyaca göre özelleştirilmiş rol ve izin tanımları', description_en: 'Customized role and permission definitions as needed', icon: 'MdPersonAdd' },
      { title: 'Modül İzinleri', title_en: 'Module Permissions', description: 'Görüntüle, Oluştur, Düzenle, Sil yetkileri', description_en: 'View, Create, Edit, Delete permissions', icon: 'MdKey' },
      { title: 'Sahiplik Doğrulaması', title_en: 'Ownership Verification', description: 'Kullanıcılar yalnızca sahip oldukları kayıtları değiştirebilir', description_en: 'Users can only modify records they own', icon: 'MdVerifiedUser' },
      { title: 'Departman Yönetimi', title_en: 'Department Management', description: 'Organizasyon yapısı ve departman atamaları', description_en: 'Organization structure and department assignments', icon: 'MdCorporateFare' },
      { title: 'Hesap Güvenliği', title_en: 'Account Security', description: '2FA, şifre politikaları ve oturum yönetimi', description_en: '2FA, password policies and session management', icon: 'MdSecurity' },
    ],
    roles: [
      { name: 'Yönetici', name_en: 'Administrator', desc: 'Tam sistem erişimi', desc_en: 'Full system access' },
      { name: 'BGYS Yöneticisi', name_en: 'ISMS Manager', desc: 'Tüm BGYS bileşenleri', desc_en: 'All ISMS components' },
      { name: 'Denetçi', name_en: 'Auditor', desc: 'Görüntüleme ve denetim', desc_en: 'View and audit' },
      { name: 'Risk Yöneticisi', name_en: 'Risk Manager', desc: 'Risk ve tedavi yönetimi', desc_en: 'Risk and treatment management' },
      { name: 'Varlık Sahibi', name_en: 'Asset Owner', desc: 'Atanmış varlıklar', desc_en: 'Assigned assets' },
      { name: 'Görüntüleyici', name_en: 'Viewer', desc: 'Salt okunur erişim', desc_en: 'Read-only access' },
    ],
    stats: [
      { value: '6', label: 'Varsayılan Rol', label_en: 'Default Roles' },
      { value: '7', label: 'Modül', label_en: 'Modules' },
      { value: '4', label: 'İzin Türü', label_en: 'Permission Types' },
      { value: '2FA', label: 'Güvenlik', label_en: 'Security' },
    ],
  },

  'politikalar': {
    id: 'politikalar',
    title: 'Politikalar ve Prosedürler',
    title_en: 'Policies & Procedures',
    badge: 'BELGE YÖNETİMİ',
    badge_en: 'DOCUMENT MANAGEMENT',
    description: 'Bilgi güvenliği politikalarınızı ve prosedürlerinizi oluşturun, versiyonlayın ve ISO 27001 kontrollerine bağlayın.',
    description_en: 'Create, version and link your information security policies and procedures to ISO 27001 controls.',
    icon: 'MdDescription',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80',
    features: [
      { title: 'Politika Oluşturma', title_en: 'Policy Creation', description: 'Kategori, sahip ve versiyon bilgileriyle politika tanımlama', description_en: 'Define policies with category, owner and version info', icon: 'MdNoteAdd' },
      { title: 'Versiyon Kontrolü', title_en: 'Version Control', description: 'Her politikanın versiyon geçmişi ve değişiklik takibi', description_en: 'Version history and change tracking for each policy', icon: 'MdHistory' },
      { title: 'Kontrol Bağlantısı', title_en: 'Control Linking', description: 'Politikaları ISO 27001 kontrollerine bağlama', description_en: 'Link policies to ISO 27001 controls', icon: 'MdLink' },
      { title: 'Gözden Geçirme', title_en: 'Review Cycles', description: 'Planlı gözden geçirme tarihleri ve hatırlatmalar', description_en: 'Scheduled review dates and reminders', icon: 'MdEventRepeat' },
      { title: 'Belge Yükleme', title_en: 'Document Upload', description: 'PDF ve DOCX formatlarında belge depolama', description_en: 'Document storage in PDF and DOCX formats', icon: 'MdUploadFile' },
      { title: 'Durum Takibi', title_en: 'Status Tracking', description: 'Aktif, İnceleme Altında, Arşivlenmiş durumları', description_en: 'Active, Under Review, Archived statuses', icon: 'MdFactCheck' },
    ],
    stats: [
      { value: '∞', label: 'Politika', label_en: 'Policies' },
      { value: '∞', label: 'Prosedür', label_en: 'Procedures' },
      { value: '3', label: 'Durum', label_en: 'Statuses' },
      { value: '93', label: 'Kontrol Bağı', label_en: 'Control Links' },
    ],
  },

  'kontrol': {
    id: 'kontrol',
    title: 'Kontrol Yönetimi',
    title_en: 'Control Management',
    badge: 'ISO 27001 EK A',
    badge_en: 'ISO 27001 ANNEX A',
    description: 'ISO 27001:2022 Ek A\'dan 4 kategoriye ayrılmış 93 kontrolün tamamını yönetin, uygulayın ve takip edin.',
    description_en: 'Manage, implement and track all 93 controls from ISO 27001:2022 Annex A across 4 categories.',
    icon: 'MdSecurity',
    image: '/images/Modules/kontrolYonetimi.png',
    features: [
      { title: 'Organizasyonel (A.5)', title_en: 'Organizational (A.5)', description: 'Politikalar, organizasyon ve varlık yönetimi kontrolleri', description_en: 'Policies, organization and asset management controls', icon: 'MdBusiness' },
      { title: 'İnsan (A.6)', title_en: 'People (A.6)', description: 'İK güvenliği ve personel kontrolleri', description_en: 'HR security and personnel controls', icon: 'MdPeople' },
      { title: 'Fiziksel (A.7)', title_en: 'Physical (A.7)', description: 'Fiziksel ve çevresel güvenlik kontrolleri', description_en: 'Physical and environmental security controls', icon: 'MdLocationOn' },
      { title: 'Teknolojik (A.8)', title_en: 'Technological (A.8)', description: 'Teknik güvenlik önlemleri ve kontrolleri', description_en: 'Technical security measures and controls', icon: 'MdMemory' },
      { title: 'Kanıt Yönetimi', title_en: 'Evidence Management', description: 'Her kontrol için destekleyici belge yükleme', description_en: 'Upload supporting documents for each control', icon: 'MdAttachment' },
      { title: 'Uyumluluk Durumu', title_en: 'Compliance Status', description: 'Uyumlu, Kısmen Uyumlu, Uyumsuz takibi', description_en: 'Compliant, Partially Compliant, Non-Compliant tracking', icon: 'MdPlaylistAddCheck' },
    ],
    controlCategories: [
      { code: 'A.5', name: 'Organizasyonel', name_en: 'Organizational', count: 37 },
      { code: 'A.6', name: 'İnsan', name_en: 'People', count: 8 },
      { code: 'A.7', name: 'Fiziksel', name_en: 'Physical', count: 14 },
      { code: 'A.8', name: 'Teknolojik', name_en: 'Technological', count: 34 },
    ],
    stats: [
      { value: '93', label: 'Toplam Kontrol', label_en: 'Total Controls' },
      { value: '4', label: 'Kategori', label_en: 'Categories' },
      { value: '37', label: 'Organizasyonel', label_en: 'Organizational' },
      { value: '34', label: 'Teknolojik', label_en: 'Technological' },
    ],
  },

  'denetimler': {
    id: 'denetimler',
    title: 'Denetim Yönetimi',
    title_en: 'Audit Management',
    badge: 'İÇ & DIŞ DENETİM',
    badge_en: 'INTERNAL & EXTERNAL',
    description: 'İç ve dış denetimleri planlayın, yürütün ve raporlayın. Bulguları takip edin ve düzeltici eylemler oluşturun.',
    description_en: 'Plan, conduct and report internal and external audits. Track findings and create corrective actions.',
    icon: 'MdFactCheck',
    image: '/images/Modules/denetimler.png',
    features: [
      { title: 'İç Denetimler', title_en: 'Internal Audits', description: 'Kapsam tanımlama, denetçi atama ve soru listesi oluşturma', description_en: 'Define scope, assign auditors and create checklists', icon: 'MdAssignment' },
      { title: 'Dış Denetimler', title_en: 'External Audits', description: 'Belgelendirme, gözetim ve yeniden belgelendirme takibi', description_en: 'Certification, surveillance and recertification tracking', icon: 'MdVerified' },
      { title: 'Bulgu Yönetimi', title_en: 'Finding Management', description: 'Uygunsuzluklar ve iyileştirme fırsatları kaydı', description_en: 'Record non-conformities and improvement opportunities', icon: 'MdBugReport' },
      { title: 'Düzeltici Eylemler', title_en: 'Corrective Actions', description: 'Kök neden analizi ve eylem planı oluşturma', description_en: 'Root cause analysis and action plan creation', icon: 'MdBuild' },
      { title: 'Denetim Raporları', title_en: 'Audit Reports', description: 'PDF, Excel ve CSV formatlarında rapor oluşturma', description_en: 'Generate reports in PDF, Excel and CSV formats', icon: 'MdSummarize' },
      { title: 'Sertifika Takibi', title_en: 'Certificate Tracking', description: 'Sertifika bilgileri ve geçerlilik tarihleri', description_en: 'Certificate information and validity dates', icon: 'MdCardMembership' },
    ],
    auditTypes: [
      { name: 'Belgelendirme', name_en: 'Certification', desc: 'İlk belgelendirme denetimi', desc_en: 'Initial certification audit' },
      { name: 'Gözetim', name_en: 'Surveillance', desc: 'Yıllık gözetim denetimi', desc_en: 'Annual surveillance audit' },
      { name: 'Yeniden Belgelendirme', name_en: 'Recertification', desc: '3 yılda bir tam denetim', desc_en: 'Full audit every 3 years' },
      { name: 'Özel Denetim', name_en: 'Special Audit', desc: 'İhtiyaç halinde özel denetim', desc_en: 'Special audit when needed' },
    ],
    stats: [
      { value: '2', label: 'Denetim Türü', label_en: 'Audit Types' },
      { value: '4', label: 'Önem Seviyesi', label_en: 'Severity Levels' },
      { value: '3', label: 'Rapor Formatı', label_en: 'Report Formats' },
      { value: '3 Yıl', label: 'Sertifika Süresi', label_en: 'Certificate Period' },
    ],
  },

  'egitim': {
    id: 'egitim',
    title: 'Eğitim ve Farkındalık',
    title_en: 'Training & Awareness',
    badge: 'ÖĞRENME PLATFORMU',
    badge_en: 'LEARNING PLATFORM',
    description: 'Bilgi güvenliği farkındalık programları oluşturun, eğitim oturumları planlayın ve çalışan kayıtlarını takip edin.',
    description_en: 'Create information security awareness programs, schedule training sessions and track employee records.',
    icon: 'MdSchool',
    image: '/images/Modules/egitim.png',
    features: [
      { title: 'Eğitim Programları', title_en: 'Training Programs', description: 'Farkındalık, role özel, teknik ve uyumluluk eğitimleri', description_en: 'Awareness, role-specific, technical and compliance training', icon: 'MdMenuBook' },
      { title: 'Oturum Planlama', title_en: 'Session Scheduling', description: 'Eğitim oturumlarını planlayın ve katılımı takip edin', description_en: 'Schedule training sessions and track attendance', icon: 'MdEvent' },
      { title: 'Çalışan Kayıtları', title_en: 'Employee Records', description: 'Her çalışan için eğitim geçmişi ve sertifikalar', description_en: 'Training history and certificates for each employee', icon: 'MdBadge' },
      { title: 'Sertifika Takibi', title_en: 'Certificate Tracking', description: 'Sertifika sona erme tarihleri ve yenileme hatırlatmaları', description_en: 'Certificate expiry dates and renewal reminders', icon: 'MdWorkspacePremium' },
      { title: 'Farkındalık Kampanyaları', title_en: 'Awareness Campaigns', description: 'Güvenlik ipuçları ve en iyi uygulamaları paylaşın', description_en: 'Share security tips and best practices', icon: 'MdCampaign' },
      { title: 'Etkinlik Ölçümü', title_en: 'Effectiveness Measurement', description: 'Testler aracılığıyla farkındalık seviyelerini ölçün', description_en: 'Measure awareness levels through tests', icon: 'MdQuiz' },
    ],
    trainingTypes: [
      { name: 'Farkındalık Eğitimi', name_en: 'Awareness Training', icon: 'MdLightbulb' },
      { name: 'Role Özel Eğitim', name_en: 'Role-Specific Training', icon: 'MdPerson' },
      { name: 'Teknik Eğitim', name_en: 'Technical Training', icon: 'MdCode' },
      { name: 'Uyumluluk Eğitimi', name_en: 'Compliance Training', icon: 'MdGavel' },
    ],
    stats: [
      { value: '4', label: 'Eğitim Türü', label_en: 'Training Types' },
      { value: '∞', label: 'Program', label_en: 'Programs' },
      { value: '∞', label: 'Oturum', label_en: 'Sessions' },
      { value: '%100', label: 'Hedef', label_en: 'Target' },
    ],
  },

  'aktivite': {
    id: 'aktivite',
    title: 'Aktivite Günlüğü',
    title_en: 'Activity Log',
    badge: 'DENETİM İZİ',
    badge_en: 'AUDIT TRAIL',
    description: 'Sistemdeki tüm eylemlerin kapsamlı denetim izini görüntüleyin. ISO 27001 günlük kaydı gereksinimlerini (A.12.4) karşılayın.',
    description_en: 'View comprehensive audit trail of all actions in the system. Meet ISO 27001 logging requirements (A.12.4).',
    icon: 'MdTimeline',
    image: '/images/Modules/aktiviteGunlugu.png',
    features: [
      { title: 'Otomatik Takip', title_en: 'Automatic Tracking', description: 'Girişler, çıkışlar ve CRUD işlemlerinin otomatik kaydı', description_en: 'Automatic recording of logins, logouts and CRUD operations', icon: 'MdAutorenew' },
      { title: 'Zengin Detaylar', title_en: 'Rich Details', description: 'Kullanıcı, eylem, varlık, zaman damgası ve IP adresi', description_en: 'User, action, asset, timestamp and IP address', icon: 'MdInfo' },
      { title: 'Arama ve Filtreleme', title_en: 'Search & Filter', description: 'Kullanıcı, eylem türü veya tarih aralığına göre arama', description_en: 'Search by user, action type or date range', icon: 'MdSearch' },
      { title: 'İstatistikler', title_en: 'Statistics', description: 'Aktivite eğilimleri ve aktif kullanıcı göstergeleri', description_en: 'Activity trends and active user indicators', icon: 'MdBarChart' },
      { title: 'IP Takibi', title_en: 'IP Tracking', description: 'Tüm kritik eylemler kaynak IP adresiyle kaydedilir', description_en: 'All critical actions logged with source IP address', icon: 'MdPublic' },
      { title: 'Veri Saklama', title_en: 'Data Retention', description: '90 gün boyunca günlük saklama politikası', description_en: '90-day log retention policy', icon: 'MdBackup' },
    ],
    actionTypes: [
      { name: 'Oluştur', name_en: 'Create', icon: 'MdAdd' },
      { name: 'Güncelle', name_en: 'Update', icon: 'MdEdit' },
      { name: 'Sil', name_en: 'Delete', icon: 'MdDelete' },
      { name: 'Giriş', name_en: 'Login', icon: 'MdLogin' },
      { name: 'Çıkış', name_en: 'Logout', icon: 'MdLogout' },
    ],
    stats: [
      { value: '5', label: 'Eylem Türü', label_en: 'Action Types' },
      { value: '90', label: 'Gün Saklama', label_en: 'Days Retention' },
      { value: 'A.12.4', label: 'ISO Uyumlu', label_en: 'ISO Compliant' },
      { value: '7/24', label: 'Kayıt', label_en: 'Logging' },
    ],
  },

  'raporlar': {
    id: 'raporlar',
    title: 'Raporlar',
    title_en: 'Reports',
    badge: 'ANALİTİK',
    badge_en: 'ANALYTICS',
    description: 'Risk tedavi planları, kontrol durumu, uyumluluk metrikleri ve denetim özetleri dahil kapsamlı raporlar oluşturun.',
    description_en: 'Generate comprehensive reports including risk treatment plans, control status, compliance metrics and audit summaries.',
    icon: 'MdAssessment',
    image: '/images/Modules/raporlar.png',
    features: [
      { title: 'Risk Tedavi Planı', title_en: 'Risk Treatment Plan', description: 'Kapsamlı risk analizi ve tedavi stratejileri raporu', description_en: 'Comprehensive risk analysis and treatment strategies report', icon: 'MdHealingOutlined' },
      { title: 'Kontrol Durumu', title_en: 'Control Status', description: 'Tüm kontrollerin uygulama ilerlemesi raporu', description_en: 'Implementation progress report for all controls', icon: 'MdPlaylistAddCheck' },
      { title: 'Uyumluluk Göstergesi', title_en: 'Compliance Dashboard', description: 'Genel BGYS uyumluluk metrikleri', description_en: 'Overall ISMS compliance metrics', icon: 'MdDashboard' },
      { title: 'Varlık Envanteri', title_en: 'Asset Inventory', description: 'Risk puanlarıyla tam varlık listesi', description_en: 'Complete asset list with risk scores', icon: 'MdInventory2' },
      { title: 'Denetim Özeti', title_en: 'Audit Summary', description: 'Denetimlerden bulgular ve öneriler', description_en: 'Findings and recommendations from audits', icon: 'MdSummarize' },
      { title: 'Eğitim Raporu', title_en: 'Training Report', description: 'Çalışan eğitim kayıtları ve boşluklar', description_en: 'Employee training records and gaps', icon: 'MdSchool' },
    ],
    exportFormats: [
      { name: 'PDF', icon: 'MdPictureAsPdf' },
      { name: 'Excel', icon: 'MdTableChart' },
      { name: 'CSV', icon: 'MdTableRows' },
    ],
    stats: [
      { value: '6', label: 'Rapor Türü', label_en: 'Report Types' },
      { value: '3', label: 'Dışa Aktarma', label_en: 'Export Formats' },
      { value: '∞', label: 'Filtre', label_en: 'Filters' },
      { value: 'Anlık', label: 'Oluşturma', label_en: 'Generation' },
    ],
  },
};

export default modullerData;
